import React, { useMemo } from 'react';
import { get } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { FormErrorType } from '@procom-labs/common';
export var useHookFieldError = function(fieldState, label, nestedFieldName) {
    var t = useTranslation('main').t;
    return useMemo(function() {
        var hasErr = Boolean(fieldState.invalid && fieldState.error);
        var errText;
        if (hasErr) {
            var fieldError = nestedFieldName ? get(fieldState.error, nestedFieldName) : fieldState.error;
            if ((fieldError === null || fieldError === void 0 ? void 0 : fieldError.message) === FormErrorType.requiredWithLabel) {
                errText = t('common.validations.requiredFieldError', {
                    label: label
                });
            } else {
                errText = (fieldError === null || fieldError === void 0 ? void 0 : fieldError.message) || '';
            }
        }
        return errText;
    }, [
        fieldState.invalid,
        fieldState.error,
        nestedFieldName,
        t,
        label
    ]);
};
